import onClick from "@/js/libs/onClick";
import qsa from "1dr-utils/helpers/elsForEach";
import getParents from "@/js/libs/getParents";

let APP = window.APP || {};

// Wait for Fetch polyfill...
APP.polyfillsReady.ready(() => {
  const calendar = document.getElementById("calendar");
  const listings = document.getElementById("listings");

  // Don't do anything if the elements aren't here.
  if (!calendar || !listings) {
    return;
  }

  let calAttr = false;
  let o = listings.style.opacity;

  let calState = {
    close: function () {
      calendar.setAttribute("aria-expanded", "false");
      listings.style.opacity = o;

      let showHide = document.querySelector(".Calendar .showhide");
      if (showHide) {
        showHide.innerHTML = "Show";
      }
      console.log("close calendar");
      qsa(".Calendar", (el) => {
        console.log(el);
        el.style.zIndex = "";
      });

      calAttr = false;
    },

    open: function () {
      calendar.setAttribute("aria-expanded", "true");
      o = listings.style.opacity;
      listings.style.opacity = 0.1;
      let showHide = document.querySelector(".Calendar .showhide");
      if (showHide) {
        showHide.innerHTML = "Hide";
      }
      qsa(".Calendar", (el) => {
        el.style.zIndex = 1000;
      });

      calAttr = true;
    },
  };

  onClick("[data-show-calendar]", function () {
    calAttr = !calAttr;

    if (calAttr) {
      calState.open();
    } else {
      calState.close();
    }
  });

  onClick(".Calendar", function (e) {
    let p = getParents(e.target, ".sticky");

    if (!p.length) {
      calState.close();
    }
  });

  // Simple wrapper for fetch, with a callback.
  // This is overly simplistic for the behaviour of the app,
  // which just does straight HTML swaps / adds and no fancy
  // dom stuff.
  const get = function (url, callback) {
    let h = new Headers();
    h.append("X-Requested-With", "XMLHttpRequest");
    let f = fetch(url, {
      mode: "cors",
      cache: "default",
      headers: h,
    });

    let canRun = true;

    let aborter = function () {
      canRun = false;
    };

    f.then((response) => {
      if (!canRun) return false;
      if (response.status == 200) {
        return response.text();
      }
    }).then((b) => {
      if (!canRun) return false;
      callback(b);
    });

    return aborter;
  };

  // Functions to trigger loading visual states, eg fade calendar,
  // add a spinner...
  const states = {
    calendar: {
      loading: function () {
        calendar.style.opacity = 0.25;
      },

      ready: function () {
        calendar.style.opacity = 1;
      },
    },

    listings: {
      loading: function (el) {
        // set lazyload spinner?
        if (el) {
          el.setAttribute("disabled", "true");
          el.innerHTML = "Loading...";
          el.style.opacity = 0.5;
        }
      },

      ready: function () {
        // hide lazyload spinner...
      },
    },
  };

  // Store an aborter function,
  // to try and cancel fetch.
  // Fetch doesn't exactly have cancels
  let aborter;

  onClick(calendar, (e) => {
    if (typeof aborter === "function") {
      aborter();
    }

    let calNav = e.target.getAttribute("data-cal-nav");
    let calAnchor = e.target.getAttribute("data-cal-anchor");

    if (calAnchor) {
      if (e.target.pathname == window.location.pathname) {
        // calState.close();
        return;
      }
    }

    if (!calNav) {
      let parents = getParents(e.target, "[data-cal-nav]");
      if (parents.length) {
        calNav = parents[0].getAttribute("data-cal-nav");
      }
    }

    if (calNav) {
      // Page the calendar
      e.preventDefault();
      states.calendar.loading();

      aborter = get(calNav, (r) => {
        states.calendar.ready();
        calendar.innerHTML = r;
      });
    }
  });

  onClick(listings, (e) => {
    if (typeof aborter === "function") {
      aborter();
    }

    let loadTrigger = e.target.getAttribute("data-load-events");

    if (loadTrigger) {
      e.preventDefault();
      let url = e.target.getAttribute("href");
      states.listings.loading(e.target);
      aborter = get(url, (r) => {
        states.listings.ready();
        e.target.remove();
        listings.innerHTML = listings.innerHTML + r;

        setTimeout(() => {
          qsa(".FadeOnLoad", (el) => {
            el.classList.remove("FadeOnLoad");
          });
        }, 500);
      });
    }
  });
});
